<template>
  <div class="home_wrap">
    <div
      ref="homeScroll"
      class="home-scroll"
    >
      <div class="red_top_bg">
        <div style="text-align: left;">
          <img
            class="logo"
            :src="app?.logo"
          >
        </div>
        <div style="top: 15px;">
          <div
            class="service "
            @click="$router.push('/notice')"
          >
            <van-icon
              name="smile-comment"
              size="30"
              color="#5b60df"
            />
          </div>
        </div>
      </div>
      <!-- <div class="red_top_bg">
			<div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
			</div>
			<div class="top_title" v-if="app">
				{{app.web_name}}
			</div>
			<div class="service " @click="$router.push('/notice')">
				<van-icon name="smile-comment" size="30"/>
			</div>
		</div> -->
      <van-swipe
        :autoplay="3000"
        lazy-render
      >
        <van-swipe-item
          v-for="(item, index) in banner"
          :key="index"
        >
          <img
            :src="item[lang]"
            width="100%"
            style="width: 100%;"
          >
        </van-swipe-item>
      </van-swipe>
		
      <div
        v-if="notifyStr"
        class="banner "
      >
        <div class="notice">
          <div class="icon">
            <!-- <img src="../images/home/notice.png" width="16px" height="16px" draggable="false"> -->
            <!-- <van-icon :name="require('../images/home/notice.png')" size="16" /> -->
            <van-icon
              name="volume"
              size="16"
              color="#825bd1"
            />
          </div>
          <div class="text">
            <marquee
              scrollamount="3"
              behavior="scroll"
            >
              {{ notifyStr }}
            </marquee>
          </div>
        </div>
      </div>
      <div class="quick-actions">
        <div
          v-for="item in quickActions"
          :key="item.name"
          class="quick-action"
          @click="goQuickAction(item)"
        >
          <img
            :src="item.icon"
            alt=""
          >
        </div>
      </div>
		
      <!-- <div style="padding: 10px;" v-if="girls">
		    <div style="margin-bottom: 10px; font-size: 16px;">{{$t('sky.gao')}}
		        <i style="background: rgb(63, 58, 91); padding: 4px; color: rgb(235, 202, 175); font-size: 12px; border-radius: 8px 0px;">
					{{$t('sky.gaodesc')}}
				</i>
		    </div>
		    <div style="display: flex; width: 100%; overflow-y: auto; flex-wrap: nowrap;">
		        <div v-for="(item, index) in girls" :key="index" class="gdgride" style="margin-right: 5px;">
					<template v-if="index%2==0">
						<div  @click="$router.push('/vprofile/'+item.id)">
							<div class="van-image"
								 style="width: 100px; height: 100px; overflow: hidden; border-radius: 8px;">
								 <img :src="item.pic" class="van-image__img" style="object-fit: cover;"></div>
							<span><i>{{$t('sky.kongjiang')}}</i></span>
							<div style="position: absolute; bottom: 10px; text-align: center; color: rgb(255, 255, 255); width: 100%; font-size: 12px;">
								{{item.name}}
							</div>
						</div>
						<div v-if="girls[index + 1]" @click="$router.push('/vprofile/'+girls[index + 1].id)">
							<div class="van-image"
								 style="width: 100px; height: 100px; overflow: hidden; border-radius: 8px;">
								 <img :src="girls[index + 1].pic" class="van-image__img" style="object-fit: cover;"></div>
							<span><i>{{$t('sky.kongjiang')}}</i></span>
							<div style="position: absolute; bottom: 10px; text-align: center; color: rgb(255, 255, 255); width: 100%; font-size: 12px;">
								{{girls[index + 1].name}}
							</div>
						</div>
					</template>
		        </div>
		        
		        <div @click="$router.push('/vchoose')" style="width: 23px; padding: 20px 5px 10px; height: 145px; margin-top: 30px; background: rgb(249, 249, 249); color: rgb(153, 153, 153); font-size: 12px;">
		            {{$t('sky.more')}}
		        </div>
		    </div>
		</div> -->
      <div
        v-if="girls.length || !girlsFinished"
        class="girls-list-wrap"
      >
        <div class="girls-list-title">
          {{ $t('sky.tuijian') }}
        </div>
        <van-list
          v-model="girlsLoading"
          :finished="girlsFinished"
          :immediate-check="false"
          :offset="100"
          :loading-text="$t('pro2.loading')"
          @load="loadGirls"
        >
          <div
            v-for="item in girls"
            :key="item.id"
            class="horizontalItem" 
            @click="$router.push('/vprofile/'+item.id)"
          >
            <div class="imgBox">
              <div
                class="van-image"
                style="width: 120px; height: 160px; overflow: hidden; border-radius: 8px;"
              >
                <img
                  :src="item.pic"
                  class="van-image__img"
                  style="object-fit: cover;"
                >
              </div>
              <span><i>{{ $t('sky.gaoduan') }}</i></span>
            </div>
            <div style="width: calc(100% - 140px);">
              <div class="top">
                <div>
                  <div
                    class="van-image"
                    style="width: 13px;"
                  >
                    <img
                      src="../images/home/vip.png"
                      class="van-image__img"
                    >
                  </div>
                  <span>{{ $t('sky.renzheng') }}</span>
                </div>
                <div>
                  <div
                    class="van-image"
                    style="width: 13px;"
                  >
                    <img
                      src="../images/home/vip.png"
                      class="van-image__img"
                    >
                  </div>
                  <span>{{ $t('sky.shirenzheng') }}</span>
                </div>
                <div style=" overflow: hidden; text-overflow: ellipsis; white-space: nowrap;line-height: 20px;font-size: 13px;">
                  {{ item.name }}
                </div>
              </div>
              <div class="tags">
                <span
                  v-if="item.keys[0]"
                  class="van-tag  van-tag--primary"
                >{{ item.keys[0] }}</span>
                <span
                  v-if="item.keys[1]"
                  class="van-tag  van-tag--success"
                >{{ item.keys[1] }}</span>
                <span
                  v-if="item.keys[2]"
                  class="van-tag  van-tag--danger"
                >{{ item.keys[2] }}</span>
                <span
                  v-if="item.keys[3]"
                  class="van-tag  van-tag--warning"
                >{{ item.keys[3] }}</span>
              </div>
              <div style="display: flex; align-items: center;">
                <span style="font-size: 14px; color: rgb(102, 102, 102);">{{ $t('sky.fee') }}：</span>
                <div
                  tabindex="0"
                  role="radiogroup"
                  class="van-rate"
                >
                  <div
                    role="radio"
                    tabindex="0"
                    aria-setsize="5"
                    aria-posinset="1"
                    aria-checked="true"
                    class="van-rate__item"
                  >
                    <i
                      data-score="1"
                      class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                      style="color: rgb(255, 210, 30); font-size: 18px;"
                    />
                  </div>
                  <div
                    role="radio"
                    tabindex="0"
                    aria-setsize="5"
                    aria-posinset="2"
                    aria-checked="true"
                    class="van-rate__item"
                  >
                    <i
                      data-score="2"
                      class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                      style="color: rgb(255, 210, 30); font-size: 18px;"
                    />
                  </div>
                  <div
                    role="radio"
                    tabindex="0"
                    aria-setsize="5"
                    aria-posinset="3"
                    aria-checked="true"
                    class="van-rate__item"
                  >
                    <i
                      data-score="3"
                      class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                      style="color: rgb(255, 210, 30); font-size: 18px;"
                    />
                  </div>
                  <div
                    role="radio"
                    tabindex="0"
                    aria-setsize="5"
                    aria-posinset="4"
                    aria-checked="true"
                    class="van-rate__item"
                  >
                    <i
                      data-score="4"
                      class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                      style="color: rgb(255, 210, 30); font-size: 18px;"
                    />
                  </div>
                  <div
                    role="radio"
                    tabindex="0"
                    aria-setsize="5"
                    aria-posinset="5"
                    aria-checked="true"
                    class="van-rate__item"
                  >
                    <i
                      data-score="5"
                      class="van-icon van-icon-star van-rate__icon van-rate__icon--full"
                      style="color: rgb(255, 210, 30); font-size: 18px;"
                    />
                  </div>
                </div>
              </div>
              <div style="color: rgb(153, 153, 153); font-size: 12px; margin: 5px 0px;line-height: 15px;">
                <span style="margin-right: 20px;">{{ $t('sky.height') }}: {{ item.height }}CM</span>
                <span>{{ $t('sky.high') }}：{{ item.xiong }} </span>
              </div>
              <div style="color: rgb(153, 153, 153); font-size: 12px; margin: 5px 0px;line-height: 15px;">
                <span>{{ $t('sky.fuwu') }}：{{ $t('sky.country') }}</span>
              </div>
              <div class="yueta">
                {{ $t('sky.yue') }}
              </div>
            </div>
          </div>
        </van-list>
      </div>


      <!-- <div class="grid-wrap ads_box  bglight">
			<a href="javascript:void(0);" @click="$router.push('/invest')" class="grid-item">
				 <img src="../images/item/1.png" draggable="false">
				<span style="color: #8389fb;">{{$t('moneybag.recharge')}}</span>
			</a>
			<a href="javascript:void(0);" @click="$router.push('/cash')" class="grid-item">
				<img src="../images/item/2.png" draggable="false">
				<span>{{$t('moneybag.withdraw')}}</span>
			</a>
		</div>
		<div v-if="app && cashes" class="ads_box" style="font-size: 16px;background-color: #ffffff;padding: 10px; display: block;box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);">
			<van-swipe style="height: 60px;" :autoplay="2000" vertical :show-indicators="false">
			  <van-swipe-item v-for="i in cashes">
				  <div  class="van-col">
						<img src="../images/shop2/head.png" alt="">
				  </div>
				  <div class="van-col">
					  <div>{{i.acc}} Penarikan berhasil!</div>
					  <div>{{$t('utils.moneyMark')}} {{i.money}}</div>
				  </div>
			  </van-swipe-item>
			</van-swipe>
		</div>
		
		<div class="tabs" v-if="items">
		    <div class="tab_item" v-for="(item, index) in items"  @click="$router.push('/buy/'+item.id)">
		        <div>
					<img :src="item.img"style="width: 100%;">
				</div>
		        <div class="txt">{{item.jtitle}}</div>
		    </div>
		</div> -->
    </div>
		
    <van-dialog
      v-model="show_tc"
      width="90%"
      :confirm-button-text="$t('utils.confirm')"
    >
      <img
        width="100%"
        src="../images/index/tanchuang.png"
      >
      <div
        class="popup"
        v-html="tc_content"
      />
    </van-dialog>
    <!-- <div v-if="msg_show" class="kefu" :class="show_kefu?'':'kefu_hide'" @click="kefu_to">
			<a v-if="show_kefu" :href="app.kefu_link" target="_blank">
				<img class="kefu_img" src="../images/shop2/kefu.png">
			</a>
			<img v-if="!show_kefu" class="kefu_img" src="../images/shop2/kefu.png">
		</div> -->
  </div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"

	import { NoticeBar } from 'vant';
	Vue.use(NoticeBar);
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Dialog,
		Field,
		List
	} from "vant";

	Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(List);

	export default {
		name: "Index",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_kefu: false,
				msg_show: true,
				loading: false,
				randomNumber: 0,
				icon: [],
				data: {item1:{show:true},item2:{show:true},item3:{show:true}},
				app:{},
				islogin:false,
				isapp:false,
				show_img: false,
				show_tz:false,
				show_tc:false,
				tc_content:"",
				number: '',
				vips:null,
				vip:null,
				about:null,
				sku:[],
				acc:null,
				girls:[],
				girlsPage: 1,
				girlsLoading: false,
				girlsFinished: false,
				girlsRequestLock: false,
				girlsLoadedPages: {},
				banner:null,
				items:null,
				cashes:null,
				timer:null,
				coindatas:null,
				intervalId:0,
				quickActions: [
					{name: "wallet", path: "/moneybag", icon: require("../images/ban3/duihuan.png")},
					{name: "notice", path: "/notice", icon: require("../images/ban3/notice.png")},
					{name: "favorite", path: "/item", icon: require("../images/ban3/m3cur.png")},
					{name: "vip", path: "/vip", icon: require("../images/ban3/vip2.png")}
				],
				curlist:[
					"James Anderson",
					"Emily Johnson",
					"Michael Brown",
					"Olivia Smith",
					"Daniel Davis",
					"Ava Martinez",
					"William Garcia",
					"Sophia Rodriguez",
					"Christopher Wilson",
					"Isabella Lee",
					"David Moore",
					"Mia Thompson",
					"Ethan White",
					"Charlotte Harris",
					"Alexander Hall",
					"Amelia Clark",
					"Matthew Young",
					"Harper Lewis",
					"Joshua Walker",
					"Evelyn King",
					"Andrew Allen",
					"Abigail Scott",
					"Benjamin Wright",
					"Elizabeth Adams",
					"Jacob Mitchell",
					"Grace Perez",
					"Samuel Collins",
					"Victoria Green",
					"Anthony Stewart",
					"Lily Rivera"
				],
				len: 0,
				notifyStr:''
			};
		},
		created() {
			this.$parent.footer('home');
		},
		mounted() {
			this.islogin = localStorage.getItem('token')!=null;
			if(!this.islogin){
				this.$router.push("/login");
			}
			this.start();
			this.$nextTick(() => {
				this.loadGirls();
			});
			// this.accinfo();
			// this.$nextTick(() => {
			// 	setTimeout(() => {
			// 	  this.startAnimation();
			// 	},200);
			// });
			//代理标识设置
			if(this.$router.history.current.query.agent){
				localStorage.setItem('agent', this.$router.history.current.query.agent);
			}
			//APP识别
			if(this.$router.history.current.query.isapp){
				localStorage.setItem('isapp', 'true');
			}
			this.isapp = localStorage.getItem('isapp')!=null;
			console.log();
			var that = this;
			document.body.addEventListener("scroll", function() {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			}, false);
			document.addEventListener('click', function(ev) {
				if (ev.target.className != 'kefu_img') {
					that.show_kefu = false;
				}
			}, false);
		},
		beforeDestroy() {
			clearInterval(this.intervalId); // 组件销毁前清除定时器
		},
		methods: {
			// startAnimation() {
			//   this.intervalId = setInterval(() => {
			// 	// 计算滚动距离
			// 	const scrossElement = this.$refs.scross;
			// 	scrossElement.style.transition = 'top 2s';
			// 	scrossElement.style.top = this.len * -25 + 'px';
				
			// 	// 动画结束后进行克隆和追加
			// 	setTimeout(() => {
			// 	  this.len++;
			// 	  const randomIndex = Math.floor(Math.random() * this.curlist.length);
			// 	  const newItem = this.curlist[randomIndex];
			// 	  this.curlist.push(newItem); // 添加新项
			// 	}, 2000);
			//   }, 2000);
			// },
			// accinfo() {
			// 	Fetch('/user/info').then((r) => {
			// 		this.acc = r.data;
			// 		this.vips= r.data.vips;
			// 		this.vip = r.data.vip;
			// 	});
			// },
			getcoinsdata() {
				Fetch('/user/getcoinsdata').then((r) => {
					this.coindatas = JSON.parse(r.data);
				});
			},
			download(){
				let downloadurl = document.createElement('A');
				downloadurl.href = this.app.app_link;
				downloadurl.target = "blank";
				downloadurl.click();

			},
			kefu_to() {
				// if (this.show_kefu) {
				// 	this.$router.push('/kefu');
				// }
				this.show_kefu = !this.show_kefu;
			},
			goQuickAction(item) {
				if(item.name=='vip'){
					Dialog.alert({
					  title: this.$t("pro2.explanation"),
					  confirmButtonText:this.$t("shopd.surebtn"),
					  message:  this.$t("pro2.vipapply"),
					  theme: 'round-button',
					}).then(() => {
					  // on close
					});
				}else{
					this.$router.push(item.path);
				}
				
				
			},
			hideDown() {
				this.show_img = false;
				this.$store.commit('setShowAdvert', false);
			},
			start() {
				Fetch('/index/int').then((r) => {
					this.data = r.data;
					this.vip = r.data.vip;
					this.banner = r.data.banner;
					this.notifyStr = r.data.notice;
					this.cashes = r.data.cashes;
					this.items = r.data.items;
					this.randomNumber = Math.floor(Math.random() * (7800 - 6877 + 1)) + 6877;
					// this.articlessun = r.data.articlessun;
					// var articles = r.data.articles;
					
					this.loading = true;
					if(r.data.popup.show==1){
						this.tc_content = r.data.popup.content;
						if(localStorage.getItem('tc')!=this.tc_content){
							localStorage.setItem('tc',this.tc_content);
							this.show_tc = true;
						}
					}
				});
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
					// this.notifyStr = this.app.notice;
				});
				
			},
			loadGirls() {
				if (this.girlsRequestLock || this.girlsFinished) {
					this.girlsLoading = false;
					return;
				}
				if (this.girlsLoadedPages[this.girlsPage]) {
					this.girlsLoading = false;
					return;
				}
				this.girlsRequestLock = true;
				const currentPage = this.girlsPage;
				this.$set(this.girlsLoadedPages, currentPage, true);
				Fetch('/index/girls', {
					page: currentPage
				}).then((r) => {
					const data = r.data || {};
					const list = data.list || [];
					for (let i = 0; i < list.length; i++) {
						list[i].keys = list[i].keystr ? list[i].keystr.split('|') : [];
					}
					const existsMap = {};
					for (let i = 0; i < this.girls.length; i++) {
						existsMap[this.girls[i].id] = true;
					}
					const newList = list.filter((item) => {
						return item.id && !existsMap[item.id];
					});
					if (newList.length > 0) {
						this.girls = this.girls.concat(newList);
						this.girlsPage++;
					}
					this.girlsFinished = !data.has_more;
					this.girlsLoading = false;
					this.girlsRequestLock = false;
				}).catch(() => {
					this.$delete(this.girlsLoadedPages, currentPage);
					this.girlsLoading = false;
					this.girlsRequestLock = false;
				});
			},
			onChange(index) {
				let els = this.$refs.dian.querySelectorAll("div");
				for (let i = 0; i < els.length; i++) {
					els[i].className = "";
				}
				els[index].className = "selected";
			},
			buy(item){
				this.sku = item;
				this.show_tz = true;
			},
			confirm(){
				Fetch("/index/item_apply", {
				  id: this.sku.id,
				  money:this.number
				}).then(r => {
					if (r.data && r.data>0) {
						this.$router.push("/invest/trx/"+r.data);
						
					} else {
						this.$router.push("/order");
					}
				  
				}).catch(err=>{
				    this.psd_val = '';
				})
			},
		   audioTitleScroll() { 
				var audio_title = $(".wrap");
				audio_title.each(function() {
					titleScroll(this);
				});

				function titleScroll(wrap) {
					var div = wrap.getElementsByTagName('div')[0];
					var span = div.getElementsByTagName('span')[0];
					var span_w = 1000;
					if (span) {
						span_w = span.offsetWidth;
					}
					var div_w = wrap.offsetWidth;
					if (div_w > span_w || div.getElementsByTagName('span').length >= 2) {
						// console.log(777);
						return false;
					}
					// console.log(666);
					div.innerHTML += div.innerHTML;
					var timer = setInterval(goLeft, 20);
					$(wrap).hover(function() {
						clearInterval(timer);
					}, function() {
						timer = setInterval(goLeft, 20);
					});

					function goLeft() {
						if (span_w <= wrap.scrollLeft) {
							wrap.scrollLeft -= span_w;
						} else {
							wrap.scrollLeft++;
						}
					}
				}
			}
		}
	};
</script>
<style lang="less" scoped>
	.home_wrap {
		// background: url(../images/shop2/2.png) no-repeat top;
		background-size: 100% 100%;
		background-attachment: fixed;
		max-width: 100%;
		height: 100vh;
		display: block;
		min-height: 100vh;
		overflow: hidden;
		padding-bottom: 0;
	}
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.home_wrap {
		width: 100%;
		min-height: 100vh;
	}
	.home-scroll {
		height: 100%;
		overflow-y: auto;
		padding-bottom: 10vh;
		box-sizing: border-box;
		-webkit-overflow-scrolling: touch;
	}
	.red_top_bg{
		position: relative;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
		background-color:#fff;
		.logo{
			height: 50px;
			margin: 0px 20px;
			margin-left: 10px;
			width: auto;
		}
		.language{
			position: absolute;
			top: 4px;
			left: 5px;
			height: 36px;
			img{
				height: 100%;
			}
		}
		.msg{
			position: absolute;
			top: 5px;
			right: 45px;
			height: 30px;
			
			img{
				height: 100%;
			}
		}
		.service{
			position: absolute;
			top: 8px;
			right: 6px;
			height: 30px;
			img{
				height: 100%;
			}
		}
		.top_title{
			text-align: center;
			font-size:18px;
			display: block;
			height: 44px;
			line-height: 44px;
		}
	}
	.langbar {
		position: relative;
	    margin-top: 44px;
		padding-top: 8px;
		height: 56px;
		background-color: #fff;

	}
    .search_box {
        width: 90%;
        height: 32px;
        background-color: #f6f6f6;
        border-radius: 17px;
		border: solid 1px #1989fa;
        margin: 8px auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px 0 14px;

        .fdj {
            width: 16px;
            height: 16px;
            background: url(../images/item/fdj.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .search_inp {
            flex: 1;
            margin: 0 8px;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            height: 20px;
        }

        .clear_inp {
            width: 20px;
            height: 20px;
            background: url(../images/item/clear.png) no-repeat center center;
            background-size: 100% 100%;
        }
    }

	.swiper-container {
		width: 100%;
		height: 120px;
		background: none;
		margin-top: 5px;
		.van-swipe-item {
			overflow: hidden;
		}

		a {
			float: left;
			width: 100%;
			height: 100%;
		}

		img {
			border-radius: 6px;
			margin-left: 2%;
			height: 100%;
			width: 96%;
		}
	}
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 60vh;
		padding: 26px 24px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}

	.wrap {
		padding-top: 10px;
		overflow: hidden;
		width: 150px;
		cursor: pointer;
	}

	.scroll {
		width: 1200px;
		height: 30px;
		line-height: 30px;
		overflow: hidden;
	}
	.notice-swipe {
		height: 40px;
		line-height: 40px;
	}
	.items_1 .item .item_btn button{
	    border-radius: 5px;
	}
	.main_problem{
		overflow: hidden;
		margin-bottom: 0px;
		padding: 10px;
		background-color: #FFFF;
		padding-bottom: 0px;
	}
	.alcenter {
	    align-items: center;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.font-bold {
	    font-weight: 700;
	}
	.ft26 {
	    font-size: 13px;
	}
	.mb10 {
	    margin-bottom: 5px;
	}
	.c_2a2a2a {
	    // color: #2a2a2a;
	}
	.ft20 {
	    font-size: 10px!important;
	}
	
	.tabs {
	    display: flex;
	    padding-top: 14px;
	    flex-direction: column;
		>ul {
		    list-style: none;
		    margin: 0;
		    padding: 0;
		    text-align: center;
			>li {
			    width: 33.33333%;
			    float: left;
			    background: none;
			    padding-bottom: 10px;
				>img {
				    width: 75%;
				    height: 75%;
				    margin: auto;
					height: 68px;
				}
				>p {
				    font-weight: 600;
				    font-size: 13px;
				    padding-top: 5px;
				    color: #fff;
				}
			}
		}
	}
	.notice_content{
		overflow: hidden;
		transition: top .5s;
		.notice_list {
			padding: 0;
		}
		.notice_item {
		    display: flex;
		    justify-content: space-between;
		    font-size: 14px;
		    height: 30px;
		    line-height: 30px;
			div{
			}
		}
		.gray {
			font-size: 12px;
			color: #ababab;
		}
	}
	.swiper-wrapper {
	    position: relative;
	    width: 100%;
	    height: 100%;
	    z-index: 1;
	    display: flex;
	    transition-property: transform;
	    box-sizing: content-box;
		.swiper-slide {
		    flex-shrink: 0;
		    width: 100%;
		    height: 100%;
		    position: relative;
		    transition-property: transform;
		}
		.van-swipe-item {
		    display: flex;
		}
		.item-left {
		    margin-right: 20px;
			img {
				overflow: hidden;
				width: 60px;
				height: 60px;
				border-radius: 100%;
				border: 5px solid #eee;
			}
		}
		.item-body {
		    flex: 1;
			text-align: left;
			line-height: 16px;
			color: #8a9089;
		}
		.people-content {
		    margin:5px 0 10px;
		    color: #8a9089;
		    font-size: 12px;
		}
		.people-name {
			font-size: 14px;
			color: #656b64;
			font-weight: 700;
		}
	}
	.ads_box{
		.items_tit{
			margin-bottom: 25px;
		}
	}
	.dz5_cont_bg {
	    background: -webkit-gradient(linear,left bottom,left top,from(rgba(229,123,130,.6)),to(rgba(237,87,99,.6)));
	    background: linear-gradient(0deg,rgba(229,123,130,.6),rgba(237,87,99,.6))
	}
	.home-dz5-activity{
	    border-radius: 5px;
	    margin: 10px 5px;
		 .activity-title {
		    display: -webkit-box;
		    display: -ms-flexbox;
		    display: flex;
		    -webkit-box-align: center;
		    -ms-flex-align: center;
		    align-items: center;
		    -webkit-box-pack: center;
		    -ms-flex-pack: center;
		    justify-content: center;
		    color: #fff
		}
		
		.activity-title:after,.activity-title:before {
		    content: "";
		    width: 14px;
		    height: 14px;
		    margin: 0 5px
		}
		
		.activity-title:before {
		    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA4CAYAAACsc+sjAAAAAXNSR0IArs4c6QAAAttJREFUaEPtmr9rFFEQxz/fJFoIIUWi2BgjnJociChYCuktgo1gI0FEBBsbm6gogtj4DyiChRCxEUGwEBtttDCgIjEREYUzFsEfCEbBS0ZG9nCzObIb73LsXt7CccXN23mfffO+O/dmxBq51I6cZuZcGyT9qPG1HaiZHQPOAr3AfWBU0s+2AjWzIeAFsC4WqZcljTloB7DQDiFsZueAiwmWV5J2Oah/rE1AzwMXEizTkgbzFroNPXQzyz1oLbIa2kJ5BK1FUke5XO6cnJysNkMn8gjaMTAwsL5arapSqfxqlkbkEXRVtK/ZoP468tCbX5XZNnDTRkFrQqFSqdQ1N9fTOTMzMdfAfFKHmtkWYBvwXNL31AGRQaOgwHBXf3+1e2FhXpXKk6/N2lP1AMzsTPTS98hxX4ckPcwC2wTQLG4atzGzvcBE4k6zkjZluXuRQEeBG3Wg+iR9ToMtEuhx4GoATVnSlq6omfUB14FB4C1wSpJ/p15mVpwVNbPHwP4Ylb8i9qRSupQXBdTMNgOfElCex5YkfUiDLRLobn/J1wHdKeldAP2X2bR2j5rZPs9IgPfANUm/01bDfzez4qyomY0Ad2Ng94ARSanHLUUDnQZ2JFZwWNKjtFUtDGh08OuJdE8C6oSkehnLIrMACvlS3bCiEEI3vknDHg17dLG2tyzXDWIUxGhJ6BUj1w2hG0I3hG78CfhRSsh1E5lVa04YghgFMQpiFMRouXOnkNRDc8uGQXWD6gbVLYTqzkZNvfHJHpF0M8NJ/daoXvO/oIeB8Tp+eiV9yeB/DLiUsJuSNLSku9PM7gAHY8be51OW9DHNUVRoeh1Vu2vmXqjaLsmT+2UvM/PeojdAV8zw70TTxka+/Y//s8T4K5JO1wPdCNyKqtbeCeKt2g+yOIqclYHbDgd4TfSopKcrGH/AK3hRVL0EPJqmVjD+ZNSz2w34vH38t7z162blWbHdmgH9A5qPdWaFygLhAAAAAElFTkSuQmCC") no-repeat 50%;
		    background-size: cover
		}
		
		.activity-title:after {
		    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAAXNSR0IArs4c6QAAAr5JREFUaEPtmj1oFFEQx3//RI2FEhTTaGkgQlIoKYKWghZaaCeWfmHaqEgQFQVBRAl2iqKIiEUasbARSzUSOBS1EWIjR0AUPyFE0YxM2MPHJXe38bJ33vIeXHO7c3O/+c/Mvvf2iZwPOZ+ZLQPaJE3njVdmNgScBBzyLjAoyfIC6oDlMMclXcwz4LikgZwAaj4FX0jaFAErR8Ab139Tw1kp6JD+mWl2JmQF6Fzq7+9fUigUXM3fAWhD1c0ScJapu7u7Y3q6q61YHPtZBtoQcTMHbAhFFSetBNiWcCyorusGTKZ5G4EfwMssZ0Ge7lNTne2TkwX35bVc+lTUsC5AM1sLPAR6Ew+PgJ2SvN4yGT1relba6hUdMzNfv09MTDho1VEvoM9d95Z5OCHpfC3HjbpeL+DrQL3Sfx6VtKdRALX8ZAF4X9LuWo4bdT0CVou0mc2XoqkVNLMO4BKwHfgEHJE0tpjqNlVBM3O4owHQF2CDpPeLBdlswOeAP0PDMSTpcl4AXwF9ZTBnJJ2NgCkj0OwUrVtBM9sBbAOeAPckhUszWhrQzAaBK4GY1yQdDsVtWUAzWwp8ADoDIFevV9Kb0netDLgOKM5TilvCZ2kEzHgm889Nxsyigi5OTNGYon+3K0qxWMhqItZgpQyKTSaJTGwyscnEJlM5B8wsdtHYRedGIK4mUh9CWIR90ViDsQZjDc49yhVrsJQVscnU2H2OM5kqAYrrwSrrwWeSNqd5t1EhxW5J2leH/bCkC7XszWxV8tK0/NYBSePhzrYfrJk92pyMU5LO1XLg181sBPATw+E4IOlmSvvrwMHgXj9S3SfpbUr7p0AoxkdgvaRvIeBp4BjQDowChyT9SulgOXAD2AW4zVVJw2lskwB1AbeBrcBn/x+S7izA3jd/H/hbYeAdsF/S49A+VC7t77bUfbkH/AMDR1hoozhRzwAAAABJRU5ErkJggg==") no-repeat 50%;
		    background-size: cover
		}
		.activity-title{
		    padding: 16px 12px;
		    font-size: 16px;
		    line-height: 24px
		}
		.activity-container{
		    display: -webkit-box;
		    display: -ms-flexbox;
		    display: flex;
		    -webkit-box-align: center;
		    -ms-flex-align: center;
		    align-items: center;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap
		}
		.item-activity {
		    width: calc(50% - 4px);
		    display: -webkit-box;
		    display: -ms-flexbox;
		    display: flex;
		    padding: 5px;
		    margin-right: 2px;
		    margin-left: 2px;
		    margin-bottom: 4px;
		    -webkit-box-align: center;
		    -ms-flex-align: center;
		    align-items: center;
		    background: url(../images/shop2/shop-item.png) no-repeat 50%;
		    background-size: cover;
		    -webkit-box-sizing: border-box;
		    box-sizing: border-box;
		    height: 72px
		}
		.item-txt {
		    width: calc(100% - 62px);
		    overflow: hidden;
			line-height: 20px;
		}
		.activity-img {
		    width: 58px;
		    height: 58px;
		    border-radius: 100%;
		    margin: 0 2px;
		    -ms-flex-negative: 0;
		    flex-shrink: 0
		}
		.activity-name{
		    margin: 4px 0;
		    color: #0151a4;
		    font-size: 14px;
		    font-weight: 700;
		    text-align: center
		}
		
		.activity-desc {
		    margin: 4px 0;
		    color: red;
		    font-size: 12px;
		    font-weight: 700;
		    text-align: center
		}
	}
	/deep/ .van-swipe{
		border-radius: 5px;
		margin: 5px;
	}
	.tabs{
	    width: 94%;
	    display: inline-block;
	    margin: 0.2rem 3%;
		.tab_item{
		    width: 29.3%;
		    float: left;
		    margin: 0.04rem 2%;
			.txt{
				text-align: center;
				font-family: PingFangSC-Regular,PingFang SC;
				-webkit-font-smoothing: antialiased;
				height: 21px;
				font-size: 12px;
				color: #000;
				line-height: 20px;
			}
		}
	}
	.van-col{
		text-align: left;
		
		div{
			color: #323232;
			font-size: 14px;
			line-height: 25px;
			height: 25px;
		}
		div:first-child{
			margin-top: 5px;
		}
		div:last-child{
			color: red;
		}
	}
	.van-col:first-child{
		img{
			width: 50px;
			height: 50px;
			margin:5px 15px;
		}
	}
	.ads_box{
		// background: rgba(255, 255, 255, 1);
		width: 92%;
		border-radius: 5px;
		margin:5px auto 0 auto;
		display: flex;
		text-align: center;
		.ads_img{
	
		}
		img{
			width: 96%;
			border-radius: 5px;
		}
	}
	.ads_box{
		.items_tit{
			margin-bottom: 25px;
		}
	}
	.inviteItem{
		padding: 0px 6px 0px 20px;
		margin-bottom: 1vh;
		display: flex;
		justify-content: space-between;
		align-items: center;
		text-align: left;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		.text{
		    color: #818181;
		    font-size: 15px;
			margin-top: 12px;
			text-align: left;
		}
		.value{
		    color: #ffa044;
		    font-size: 18px;
		    margin-top: 12px;
			text-align: left;
		}
		.f44 {
		    font-size: 25px;
		}
		.f20 {
		    font-size: 12px;
			margin-top: 12px;
			line-height: 20px;
		}
	}
	.bglight, .bglight2 {
	    background: linear-gradient(90deg,#fdebd5,#fff5ec)!important;
	}
	.grid-wrap {
		display: flex;
		grid-template-columns: repeat(3,1fr);
		font-size: 14px;
		text-align: center;
		background: none !important;
		:nth-child(1) {
			margin: 5px;
			margin-left: 0; 
		}
		:nth-child(2) {
			margin: 5px;
			margin-right: 0;
		}
		.grid-item {
			width: 50%;
			line-height: 50px;
			margin-bottom:5px;
			background: #FFF;
			padding: 5px;
			border-radius: 5px;
				box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
			.icon {
				display: flex;
				align-items: center;
				justify-content: center;
				height: 51px;
				background: no-repeat 50% 50%/6.93333vw 6.93333vw;
			}
			img{
				vertical-align: top;
				width: 36px;
				margin: 5px;
			}
			span{
				font-size: 16px;
				color: #fa9832;
			}
		}
	}
	.home_module{
	    width: 90%;
	    margin: 0 5%;
	    color: #232f3e;
		h3{
		    height: 30px;
			display: block;
			font-size: 18px;
			margin-block-start: 1em;
			margin-block-end: 1em;
			margin-inline-start: 0px;
			margin-inline-end: 0px;
			font-weight: bold;
			margin-bottom: 0;
		}
		.module2_content{
		    width: 100%;
			padding-bottom: 100px;
		    display: flex;
		    justify-content: space-between;
		    flex-wrap: wrap;
		    align-items: center;
			img{
				height: 100%;
				border-radius: 10px;
				margin: 2% 0;
			}
			a{
				height: 68px;
				border-radius: 10px;
				margin: 2% 0;
			}
		}
		.home_nav{
		    width: 100%;
		    height: 140px;
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    font-size: 15px;
			>div:first-child {
			    width: 48%;
			    height: 100%;
			    display: flex;
			    flex-direction: column;
			    align-items: center;
			    justify-content: space-between;
				.nav1{
				    background-color: #f4e1ff;
				}
				.nav2{
				    background-color: #ffd9e7;
				}
				.nav3{
				    background-color: #feeba9;
				}
				.nav_content{
				    width: 100%;
				    height: 30%;
				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				    border-radius: 5px;
				    padding: 5px;
					>div:first-child {
					    width: 70%;
					    display: flex;
					    align-items: center;
					}
					.uniui-forward:before {
					    content: "\e660";
					}
					.uni-icons {
					    font-family: uniicons;
					    text-decoration: none;
					    text-align: center;
						img{
							height: 18px;
							width: 18px;
						}
					}
					img{
					    width: 26px;
					    height: 26px;
					}
					p{
					    margin-left: 3%;
					}
				}
			}
			>div:last-child {
				width: 48%;
				height: 100%;
				display: flex;
				border-radius: 5px;
				flex-direction: column;
				align-items: center;
				justify-content: space-between;
				background-color: #c3cdff;
				.rightAll{
				    position: relative;
				    box-sizing: border-box;
				    width: 100%;
				    height: 100%;
					.module_right{
					    width: 100%;
					    padding: 0 5px;
					    display: flex;
					    justify-content: space-between;
					    align-items: center;
					    margin: 3% 0;
					}
					img{
					    width: 100%;
					    height: 70%;
					}
				}
			}
		}
	}
	.vip-item {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    padding: 2vw 3vw;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item .vip-img {
	    width: 50px;
	    height: 50px;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 50vw;
		margin-top: 10px;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 3.8vw;
	    color: #222;
		margin-bottom: 1vw;
		margin-top: 3vw;
	}
	.vip-item .vip-info .vip-desc {
		font-size: 12px;
		color: #999;
		line-height: 1.5em;
	}
	.vip-item .action-box .ord{
		font-size: 2vw;
		font-weight: bold;
		line-height: 6vw;
		color: rgb(74, 193, 171);
	}
	.vip-item .action-box .i-icon {
	    padding: 2vw 3vw;
	    text-align: center;
	    background-color: #cc2996;
	    font-size: 14px;
	    color:#fff;
	    border-radius: 1.5em;
	    cursor: pointer;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #cc2996;
	    padding: 24px 16px 8px 16px;
	    border-radius: 50%;
	    top: -20px;
	    left: 40%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
	
	.banner {
	   height: 52px;
	   display: flex;
	   width: 100%;
	   background: none;
	   background-size: 100% 100%;
	   position: relative;
	   flex-direction: column;
		p {
		    padding: 67px 0 0 52px;
		    font-size: 15px;
		    color: #b4ffec;
		    font-weight: 500;
		}
		>div {
		    padding: 10px 0 0 52px;
			font-size: 24px;
			font-weight: 700;
			position: relative;
			display: flex;
			z-index: 2;
			align-items: center;
			>span {
			    font-size: 16px;
			    margin-left: 5px;
			}
		}
		.notice {
			height: 52px;
			padding: 0;
			font-size: 14px;
			font-weight: 400;
			display: block;
			width: 100%;
			color: #727d91;
			// background: linear-gradient(270deg, #0c7f9e, #ffd543);
			.icon {
				width: 35px;
				height: 35px;
				line-height: 35px;
				text-align: center;
				
				border-radius: 35px;
				margin-top: 1.2vh;
				margin-left: 2%;
				img {
				    width: 40px;
				    position: absolute;
				    top: 8px;
				    left: 8px;
				}
			}
			.text {
			   position: absolute;
			   left: 48px;
			   top: 1px;
			   right: 0;
			   line-height: 35px;
			   height: 35px;
			   border-radius: 5%;
			   padding: 0 3%;
			   margin-right: 3%;
			   margin-top: 1vh;
			   padding-left: 0;
			}
		}
	}
	.quick-actions {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		width: calc(100% - 14px);
		height: 80px;
		border-radius: 10px;
		margin: 0px auto 0;
		background: #fff;
		// box-shadow: 0 8px 14px rgba(0, 0, 0, .08);
		overflow: hidden;
	}

	.quick-action {
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f2f6;
		cursor: pointer;
	}

	.quick-action:last-child {
		border-right: 0;
	}

	.quick-action img {
		display: block;
		width: 36px;
		height: 36px;
		object-fit: contain;
	}

	// .quick-action:nth-child(4) img {
	// 	width: 52px;
	// 	height: 52px;
	// 	filter: hue-rotate(160deg) saturate(1.4);
	// }

	@media (max-width: 420px) {
		.quick-actions {
			width: 100%;
			height: 112px;
			margin: 12px auto 14px;
		}

		.quick-action img {
			width: 38px;
			height: 38px;
		}

		.quick-action:nth-child(4) img {
			width: 44px;
			height: 44px;
		}
	}
	.tab_item img{
		border-radius: 10%;
	}
	.gdgride {
	    padding-right: 10px
	}
	
	.gdgride>div {
	    position: relative;
	    overflow: hidden;
	    border-radius: 8px;
		margin: 5px 0px;
	}
	
	.gdgride>div>span {
	    position: absolute;
	    z-index: 9;
	    background-color: #ebcaaf;
	    color: #8d684b;
	    transform: rotate(45deg);
	    width: 20vw;
	    height: 20vw;
	    font-size: 3vw;
	    top: -11vw;
	    right: -11vw
	}
	
	.gdgride>div>span>i {
	    position: absolute;
	    bottom: 5px;
	    left: 50%;
	    transform: translateX(-50%);
		word-break: auto-phrase;
	    font-weight: 700;
		font-size: 10px;
	}
.horizontalItem {
	display: flex;
	border-bottom: 1px solid #eee;
	padding: 10px 0 10px
}

.girls-list-wrap {
	padding: 10px;
	padding-bottom: 60px;
}

.girls-list-title {
	font-size: 16px;
}

.horizontalItem .imgBox {
	position: relative;
	overflow: hidden;
	border-radius: 8px;
	margin-right: 20px
}

.horizontalItem .imgBox>span {
	position: absolute;
	z-index: 9;
	background-color: #ebcaaf;
	color: #8d684b;
	transform: rotate(45deg);
	width: 90px;
	height: 90px;
	top: -50px;
	right: -50px;
}

.horizontalItem .imgBox>span>i {
	position: absolute;
	bottom: 5px;
	left: 50%;
	transform: translateX(-50%);
	font-weight: 700;
	font-size: 13px;
}

.horizontalItem .top {
	display: flex
}

.horizontalItem .top>div:first-child,.horizontalItem .top>div:nth-child(2) {
	background: linear-gradient(180deg,#e7caaf,#fff7ed);
	color: #a4826b;
	font-weight: 600;
	font-size: 12px;
	padding: 3px;
	margin-right: 10px
}

.horizontalItem .top>div:last-child {
	margin-left: 5px;
	font-size: 4vw
}

.horizontalItem .tags {
	display: flex;
	margin: 5px 0 5px;
	flex-wrap: wrap
}

.horizontalItem .tags>.van-tag {
	padding: 5px;
	font-size: 12px;
	margin: 0 5px 5px 0;
	border-radius: 8px
}

.horizontalItem .yueta {
	background: linear-gradient(90deg,#df35ad,#4f1db5);
	color: #fff;
	border-radius: 8px;
	padding: 10px 0;
	text-align: center;
	font-size: 12px
}

.OnlineMatching{
    height: 28vw;
    overflow: hidden
}

.OnlineMatching li {
    text-align: center;
    color: #fff;
    font-size: 4vw;
    margin-top: 10px
}

#app3 {
	width: 100%;
	height: 520px;
	overflow: hidden;
	position: relative;
	padding-left: 5%;
  .scross {
	position: relative;
	top: 0;
  }
  
  .list {
	height: 30px;
	line-height: 30px;
	color: #FFF;
	font-size: 16px;
	text-align: center;
	// background-color: #f1f1f1;
	margin-bottom: 0;
  }
  .list,.val{
	  display: flex;
	  align-items: center; 
	  // border-bottom: 1px solid #f5f5f5;
	  padding:0 ;
	  width: 100%;
  }
  .list>.val>.lef{
	  margin-right:8px;
	  display: inline-block;
	  width: 50px;
	  height: 50px;
	  overflow: hidden;
  }
  .list>.val>.lef>img{
	  display: inline-block;
	  width: 50px;
	  height: 50px;
	  border-radius: 50%;
	  /*background: red;*/
  
  
  }
  .list>.val>.rig>.nav{
	 font-size: 14px;
	 font-weight: bold;
	 margin-bottom: 6px;
  }
  .list>.val>.rig>.navVal{
	  font-size: 12px;
	text-align: left;
	  margin-bottom: 6px;
   }
   .list .rig{
	 line-height: 20px;
   }
}
</style>
